export enum MfaPreferenceActionDispatchTypes {
  MASTER_MFA_PREFERENCE_INVOKE = "MASTER_MFA_PREFERENCE_INVOKE",
  MASTER_MFA_PREFERENCE_SUCCESS = "MASTER_MFA_PREFERENCE_SUCCESS",
}

export enum UserDetailsActionDispatchTypes {
  UPDATE_USER_DETAILS_INVOKE = "UPDATE_USER_DETAILS_INVOKE",
  UPDATE_USER_DETAILS_SUCCESS = "UPDATE_USER_DETAILS_SUCCESS",
  UPDATE_USER_DETAILS_ERROR = "UPDATE_USER_DETAILS_ERROR",
  UPDATE_USER_DETAILS_RESET = "UPDATE_USER_DETAILS_RESET",
}

export const NotificationLabel =
  "Multi-Factor Authentication (MFA) is a security method that requires users to provide more than one form of verification to log in to an account. tango may use phone, email or both methods to allow you to gain entrance into the portal. If you choose phone or both for your MFA preference, please ensure that the phone number given can receive text messages.";

export enum ResetPasswordActionDispatchTypes {
  RESET_PASSWORD_INVOKE = "RESET_PASSWORD_INVOKE",
  RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR",
  RESET_PASSWORD_RESET = "RESET_PASSWORD_RESET",
}

export enum ResendRegistrationActionDispatchTypes {
  RESEND_REGISTRATION_INVOKE = "RESEND_REGISTRATION_INVOKE",
  RESEND_REGISTRATION_SUCCESS = "RESEND_REGISTRATION_SUCCESS",
  RESEND_REGISTRATION_ERROR = "RESEND_REGISTRATION_ERROR",
  RESEND_REGISTRATION_RESET = "RESEND_REGISTRATION_RESET",
}

export enum UserStatusActionDispatchTypes {
  USER_STATUS_INVOKE = "USER_STATUS_INVOKE",
  USER_STATUS_SUCCESS = "USER_STATUS_SUCCESS",
  USER_STATUS_ERROR = "USER_STATUS_ERROR",
  USER_STATUS_RESET = "USER_STATUS_RESET",
}